module.exports = __webpack_public_path__ + "img/excel.414a5948.png";